// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * OPC UA standard aggregate functions
 * @export
 */
export const AggregateFunctionEnum = {
    Average: 'Average',
    Minimum: 'Minimum',
    Maximum: 'Maximum',
    Count: 'Count',
    Total: 'Total',
    Range: 'Range'
} as const;
export type AggregateFunctionEnum = typeof AggregateFunctionEnum[keyof typeof AggregateFunctionEnum];


export function instanceOfAggregateFunctionEnum(value: any): boolean {
    for (const key in AggregateFunctionEnum) {
        if (Object.prototype.hasOwnProperty.call(AggregateFunctionEnum, key)) {
            if (AggregateFunctionEnum[key as keyof typeof AggregateFunctionEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AggregateFunctionEnumFromJSON(json: any): AggregateFunctionEnum {
    return AggregateFunctionEnumFromJSONTyped(json, false);
}

export function AggregateFunctionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AggregateFunctionEnum {
    return json as AggregateFunctionEnum;
}

export function AggregateFunctionEnumToJSON(value?: AggregateFunctionEnum | null): any {
    return value as any;
}

export function AggregateFunctionEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): AggregateFunctionEnum {
    return value as AggregateFunctionEnum;
}

